// @flow
import * as React from 'react';
import type { Element } from 'react';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

import {
  StyledForm, StyledSelectInput, StyledIconWrapper, StyledIcon
} from './styles';
import type { Props } from './types';

const Select = ({
  label, setted, children, city, ...restProps
}: Props): Element<any> => (
  <StyledForm setted={setted} city={city}>
    <StyledSelectInput {...restProps}>
      <option value="">{label}</option>
      {children}
    </StyledSelectInput>

    <StyledIconWrapper>
      <StyledIcon icon={faCaretDown} size="1x" />
    </StyledIconWrapper>
  </StyledForm>
);

Select.defaultProps = {
  setted: false
};

export default Select;
